    <div id="AssotnVerifyModal" 
        class="modal fade community-pic-modal-container" 
        tabindex="-1" 
        role="dialog" 
        [config]="{ show: true, backdrop: 'relative' }" 
        (onHidden)="cancel()" 
        bsModal 
        #autoShownModal="bs-modal">
        <div class="custom-theme-modal modal-dialog modal-dialog-centered mt-0 mb-0" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <span class="close-modal float-right"
                        (click)="cancel()"> <img src="assets/themes/icons/cancel.svg" alt="close icon" />
                    </span>
                </div>
                <div class="modal-body">
                    <h4 class="heading-4 mb-2">Change Community pic</h4>
                    <div *ngIf="images_preview!=undefined && images_preview!=null" class="text-center overflow-hidden rounded position-relative">
                        <img class="mx-auto rounded" [src]="images_preview?.local" alt="preview image" />
                    </div>
                </div> 
                <div class="modal-footer">
                    <div class="text-right mt-2">
                        <button 
                            (click)="cancel()" 
                            class="btn-design small outline mr-2">
                            {{multilang.languageText.community.key83}}
                        </button>
                        <button 
                            (click)="fileUploadingProcess()" 
                            class="btn-design small filled ">
                                <span *ngIf="api_in_process==true" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
                                </span> 
                            {{multilang.languageText.community.key172}}
                        </button>
                    </div>
                </div>       
            </div>
        </div>
    </div>